module.exports = __webpack_public_path__ + "static/media/wrath.e163ba45.mp3";